import { maritimeWarningsPath } from "@/features/dashboard/features/general/warning-page-paths";
import { useDashboardData, useDashboardWarningSettings } from "@/features/shared/hooks";
import { useTranslation } from "@/lib/i18n";
import { useToolbarLabelWithCode } from "@/features/shared/hooks/use-warning-page-defaults";
import { maritimeToolbarLevel } from "@/lib/warning-page-copy";
import {
  findNavigationElementByKind,
  NAVIGATION_ELEMENT_KIND,
} from "@/lib/navigation-element-kinds";

import { useMaritimeWarningColor } from "./use-maritime-warning-color";
import { WarningToolLink } from "./warning-tool-link";

/** Maritime warnings page shortcut. Only while that page has an actual warning. */
export function MaritimeWarningTool() {
  const { t } = useTranslation();
  const { navigationElements } = useDashboardData();
  const { selectedDashboard, maritimeWarningPage } = useDashboardWarningSettings();
  const withCode = useToolbarLabelWithCode();
  // Undefined when the page is off, while loading, or on green.
  const color = useMaritimeWarningColor();
  const element = findNavigationElementByKind(
    navigationElements,
    NAVIGATION_ELEMENT_KIND.maritimeWarningsPage,
  );

  // Undefined while the page is off or loading, or when the level is green.
  if (!selectedDashboard || !color) return null;

  // Highest maritime level in the enabled domains, by color name only ("Kust & Zee: Geel");
  // the maritime page never says "code".
  const level = maritimeToolbarLevel(t(`code.${color}`));

  return (
    <WarningToolLink
      to={element?.full_path || maritimeWarningsPath(selectedDashboard.slug)}
      color={color}
      label={withCode(maritimeWarningPage.toolbarLabel, level)}
      indicatorLabel={level}
    />
  );
}
